(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["recipe-posts"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.recipe-filter-bar').forEach(function (filterBar) {
      var sectionId = filterBar.dataset.section;
      var grid = document.getElementById('recipe-grid-' + sectionId);
      var nav = document.querySelector('.recipe-pagination[data-section="' + sectionId + '"]');
      if (!grid || !nav) return;

      var allCards = Array.from(grid.querySelectorAll('.recipe-pagination-card'));
      var perPage = parseInt(grid.dataset.perPage, 10) || 8;
      var currentPage = 0;
      var visibleCards = allCards;

      function cardCategories(card) {
        try { return JSON.parse(card.dataset.categories || '[]') || []; } catch (e) { return []; }
      }

      function getVisible(filter) {
        if (filter === 'all') return allCards;
        return allCards.filter(function (card) {
          return cardCategories(card).indexOf(filter) !== -1;
        });
      }

      // Build filter buttons from card data
      var allCats = [];
      allCards.forEach(function (card) {
        cardCategories(card).forEach(function (cat) {
          if (cat && allCats.indexOf(cat) === -1) allCats.push(cat);
        });
      });
      allCats.sort();
      if (allCats.length > 0) {
        var allBtn = document.createElement('button');
        allBtn.className = 'recipe-filter__btn active';
        allBtn.dataset.filter = 'all';
        allBtn.textContent = 'All';
        filterBar.appendChild(allBtn);
        allCats.forEach(function (cat) {
          var btn = document.createElement('button');
          btn.className = 'recipe-filter__btn';
          btn.dataset.filter = cat;
          btn.textContent = cat;
          filterBar.appendChild(btn);
        });
      }

      function buildNav(totalPages) {
        nav.innerHTML = '';
        if (totalPages <= 1) return;

        var prevBtn = document.createElement('button');
        prevBtn.className = 'recipe-pagination__btn recipe-pagination__prev btn btn--secondary';
        prevBtn.setAttribute('aria-label', 'Previous page');
        prevBtn.disabled = true;
        prevBtn.textContent = '‹';
        nav.appendChild(prevBtn);

        var pagesSpan = document.createElement('span');
        pagesSpan.className = 'recipe-pagination__pages';
        for (var i = 0; i < totalPages; i++) {
          (function (pageIndex) {
            var btn = document.createElement('button');
            btn.className = 'recipe-pagination__page btn' + (pageIndex === 0 ? ' active' : '');
            btn.setAttribute('aria-label', 'Page ' + (pageIndex + 1));
            btn.setAttribute('aria-current', pageIndex === 0 ? 'page' : 'false');
            btn.dataset.page = pageIndex;
            btn.textContent = pageIndex + 1;
            btn.addEventListener('click', function () { goToPage(pageIndex); });
            pagesSpan.appendChild(btn);
          })(i);
        }
        nav.appendChild(pagesSpan);

        var nextBtn = document.createElement('button');
        nextBtn.className = 'recipe-pagination__btn recipe-pagination__next btn btn--secondary';
        nextBtn.setAttribute('aria-label', 'Next page');
        nextBtn.disabled = totalPages <= 1;
        nextBtn.textContent = '›';
        nav.appendChild(nextBtn);

        prevBtn.addEventListener('click', function () {
          if (currentPage > 0) goToPage(currentPage - 1);
        });
        nextBtn.addEventListener('click', function () {
          if (currentPage < totalPages - 1) goToPage(currentPage + 1);
        });
      }

      function updateNavState(totalPages) {
        var pageButtons = nav.querySelectorAll('.recipe-pagination__page');
        var prevBtn = nav.querySelector('.recipe-pagination__prev');
        var nextBtn = nav.querySelector('.recipe-pagination__next');
        pageButtons.forEach(function (btn) {
          var active = parseInt(btn.dataset.page, 10) === currentPage;
          btn.classList.toggle('active', active);
          btn.setAttribute('aria-current', active ? 'page' : 'false');
        });
        if (prevBtn) prevBtn.disabled = currentPage === 0;
        if (nextBtn) nextBtn.disabled = currentPage === totalPages - 1;
      }

      function render() {
        var totalPages = Math.ceil(visibleCards.length / perPage);
        allCards.forEach(function (card) { card.classList.add('hidden'); });
        var start = currentPage * perPage;
        visibleCards.slice(start, start + perPage).forEach(function (card) {
          card.classList.remove('hidden');
        });
        buildNav(totalPages);
        updateNavState(totalPages);
      }

      function goToPage(page) {
        currentPage = page;
        render();
        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      function slugify(str) {
        return str.toLowerCase().trim().replace(/\s+/g, '-');
      }

      function activateFilter(filter, updateHash) {
        filterBar.querySelectorAll('.recipe-filter__btn').forEach(function (b) {
          b.classList.toggle('active', b.dataset.filter === filter);
        });
        visibleCards = getVisible(filter);
        currentPage = 0;
        render();
        if (updateHash) {
          if (filter === 'all') {
            history.replaceState(null, '', location.pathname + location.search);
          } else {
            history.replaceState(null, '', '#' + slugify(filter));
          }
        }
      }

      function applyHashFilter(scroll) {
        var raw;
        try { raw = decodeURIComponent(location.hash.slice(1)); } catch (e) { raw = ''; }
        raw = raw.toLowerCase();
        if (!raw) return false;
        var match = null;
        for (var i = 0; i < allCats.length; i++) {
          if (slugify(allCats[i]) === raw) { match = allCats[i]; break; }
        }
        if (!match) return false;
        activateFilter(match, false);
        if (scroll) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return true;
      }

      filterBar.querySelectorAll('.recipe-filter__btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          activateFilter(btn.dataset.filter, true);
        });
      });

      window.addEventListener('hashchange', function () {
        if (!location.hash || location.hash === '#') {
          activateFilter('all', false);
        } else {
          applyHashFilter(true);
        }
      });

      render();
      applyHashFilter(true);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
